
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "50f53ab5-3006-44ae-a70e-1f5ada9aa664"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/home/prow/go/src/github.com/bittorrent/ads-content-website/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
